<div class="flex flex-col h-full">
  <p-toolbar>
    <ng-template pTemplate="start">
      <div class="flex gap-4">
        <p-iconfield>
          <p-inputicon styleClass="pi pi-search" />
          <input
            type="text"
            pInputText
            [(ngModel)]="jobopslagService.searchText"
            (keyup.enter)="jobopslagService.onSearch()" />
        </p-iconfield>
        <div class="flex items-center">
          <p-checkbox
            [(ngModel)]="jobopslagService.medtagSlettede"
            [binary]="true"
            (onChange)="jobopslagService.onSearch()" />
          <label class="ml-2"> Medtag slettede </label>
        </div>
      </div>
    </ng-template>
  </p-toolbar>

  @let apiResponse = data.value();
  @if (apiResponse) {
    <p-table
      [value]="apiResponse.data"
      [loading]="data.isLoading()"
      [showGridlines]="true"
      stripedRows
      selectionMode="single"
      [metaKeySelection]="true"
      [(selection)]="jobopslagService.selectedJobopslag"
      (onRowSelect)="onRowSelect($event)"
      dataKey="id"
      [scrollable]="true"
      scrollHeight="flex"
      class="flex-1 overflow-hidden p-datatable-sm mt-4">
      >
      <ng-template pTemplate="header">
        <tr>
          <th>Jobbeskrivelse</th>
          <th>Oprettet</th>
        </tr>
      </ng-template>
      <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
        <tr [pSelectableRow]="item" class="cursor-pointer">
          <td>{{ item.beskrivelse }}</td>
          <td>{{ item.oprettet | date: 'dd-MM-yyyy' }}</td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
